/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetAdminCompetitionResultsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetAdminCompetitionResultsArgs, useGetAdminCompetitionResultsSpec, useGetAdminCompetitionResultsRealtime, useGetAdminCompetitionResultsPagination } from '../specs/admin.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetAdminCompetitionResultsRow } from '../openapi-types.gen.js';
export type { useGetAdminCompetitionResultsArgs } from '../specs/admin.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetAdminCompetitionResultsPaginationContract = useGetAdminCompetitionResultsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetAdminCompetitionResultsInfinite` — both
 * read/write the same `PagedData<GetAdminCompetitionResultsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): competitionId.
 */
const _useGetAdminCompetitionResults = createListHook({
  spec: useGetAdminCompetitionResultsSpec,
  realtime: useGetAdminCompetitionResultsRealtime,
  entityKey: null,
  pagination: _useGetAdminCompetitionResultsPaginationContract,
});
export const useGetAdminCompetitionResults = _useGetAdminCompetitionResults as (args: useGetAdminCompetitionResultsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminCompetitionResults>;


/**
 * Auto-infinite: same cache as `useGetAdminCompetitionResults`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetAdminCompetitionResults` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetAdminCompetitionResultsInfinite = createListHook({
  spec: useGetAdminCompetitionResultsSpec,
  realtime: useGetAdminCompetitionResultsRealtime,
  entityKey: null,
  pagination: _useGetAdminCompetitionResultsPaginationContract,
  autoLoadMore: true,
});
export const useGetAdminCompetitionResultsInfinite = _useGetAdminCompetitionResultsInfinite as (args: useGetAdminCompetitionResultsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminCompetitionResultsInfinite>;


/**
 * Per-field subscription hook for the `useGetAdminCompetitionResults` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetAdminCompetitionResultsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetAdminCompetitionResultsField = createFieldHook<GetAdminCompetitionResultsRow>('useGetAdminCompetitionResultsField');

/**
 * Hover/intent prefetch companion for `useGetAdminCompetitionResults` (also covers
 * `useGetAdminCompetitionResultsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetAdminCompetitionResults();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetAdminCompetitionResults = createPrefetchHook(useGetAdminCompetitionResultsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetAdminCompetitionResultsArgs>;
